import { WatchlistUiState, INITIAL_WATCHLIST_UI_STATE } from '../watchlist-ui-state';
import { Action } from '@ngrx/store';
import { SET_CURRENT_USER_ACTION, SetCurrentUserAction } from '../actions/SetCurrentUserAction';

export function watchlistUiState(state: WatchlistUiState = INITIAL_WATCHLIST_UI_STATE, action: Action): WatchlistUiState {

    switch (action.type) {

        case SET_CURRENT_USER_ACTION:
            return handleSetCurrentUserAction(state, action);
        default:
            return state;

    }

}

function handleSetCurrentUserAction(state: WatchlistUiState, action: SetCurrentUserAction) {
    const newState = Object.assign({}, state);
    newState.userId = action.payload;
    return newState;
}







// WEBPACK FOOTER //
// ./node_modules/@nw/ui-watchlist/store/reducers/watchlistUiStateReducer.ts